// Convertit une heure en format "HH:mm:ss:SSS" en date avec l'heure ajustée.

/**
 * @typedef {Object} Props
 * @property {import("dayjs").Dayjs} date
 * @property {string} time // exemple: "HH:mm:ss:SSS"
 */
/**
 * @param {Props} props
 */
export default function adjustDateWithTime({ date, time }) {
  const [hours, minutes, second, millisecond] = time.split(":").map(Number);
  return date
    .clone()
    .hour(hours ?? 0)
    .minute(minutes ?? 0)
    .second(second ?? 0)
    .millisecond(millisecond ?? 0);
}
